module.exports = {
  emptyMessage: 'Lengkapi dengan nama sesuai yang tertera di kartu.',
  containsNumberMessage: 'Nama tidak boleh mengandung angka',
  maxLengthMessage: 'Maaf! Anda telah melebihi jumlah karakter yang diizinkan, silakan isi ulang.',
  defaultMessage: 'Maaf! Nama ini tidak valid.',
};
